import Vue from 'vue';
import '@common/utils/event.js';
import '@common/utils/errorPage.js';
import '@/iamteacherpc/utils/alertConfirm.js';
import '@/iamteacherpc/utils/modalUtil.js';
import '@/iamteacherpc/utils/serviceType';
import App from './App.vue';
import router from './router.js';
import store from '@common/store';
import axios from 'axios';
import VueAxios from 'vue-axios';
import 'what-input';
import 'core-js/es/promise/finally'; // iOS 10에 promise finally가 없음
import i18n from '@common/i18n.js';
import VueMeta from 'vue-meta';
import './directive';

Vue.config.productionTip = false;

Vue.use(VueMeta);

new Vue({
    router,
    store,
    VueAxios,
    axios,
    i18n,
    render: h => h(App),
}).$mount('#app');

if (module.hot) {
    module.hot.accept(); // already had this init code

    module.hot.addStatusHandler(status => {
        if (status === 'prepare') console.clear();
    });
}
